<template>
  <div>
    <component :is="headerComponent" @openSidebar="onOpenSidebar" :isTop="isTop"></component>
    <main-sidebar :isOpen="isOpenSidebar" :isExtend="isExtendSidebar"
      @openSidebar="onOpenSidebar" @extendSidebar="onExtendSidebar"></main-sidebar>
      <div class="flex-column">
        <keep-alive v-if="isCacheComponent" include="CreateReportPosition,CreateReportLayout,DaikinCoverReport">
          <router-view style="flex:1" :key="$route.fullPath" @returnHideCopyright="returnHideCopyright()"></router-view>
        </keep-alive>
        <router-view v-else style="flex:1" :key="$route.fullPath"></router-view>
        <copyright v-if="isShowCopyright"></copyright>
      </div>
  </div>
</template>

<script>
import MainHeader from '@/components/layouts/MainHeader';
import MainSidebar from '@/components/layouts/MainSidebar';
import HeaderBeforeLogin from '@/components/layouts/HeaderBeforeLogin';
import Copyright from '@/components/layouts/Copyright'

export default {
  components: { MainHeader, MainSidebar, HeaderBeforeLogin, Copyright },
  name: 'NormalLayout',
  data () {
    return {
      isOpenSidebar: false,
      isExtendSidebar: false,
      isCacheComponent: false,
      isTop: false,
      isShowCopyright: true
    }
  },
  methods: {
    onOpenSidebar (value) {
      const el = document.body;
      this.isOpenSidebar = value;
      if (value) {
        el.classList.add('sidebar-open');
      } else {
        this.isExtendSidebar = false;
        el.classList.remove('sidebar-open');
      }
    },
    onExtendSidebar (value) {
      this.isExtendSidebar = value
    },
    returnHideCopyright () {
      this.isShowCopyright = false
    }
  },
  computed: {
    headerComponent () {
      const arrayComponentHeaderGuest = ['Login'];
      if (arrayComponentHeaderGuest.includes(this.$route.name)) return 'header-before-login';
      return 'main-header';
    }
  },
  watch: {
    $route (to) {
      const reportComponent = ['CreateReportPosition', 'CreateReportPositionFromApp', 'CreateReportLayout', 'DaikinCoverReport'];
      this.isCacheComponent = reportComponent.includes(to.name);
      this.isTop = !!this.$route.meta.isTop
      if (this.isCacheComponent && !this.isShowCopyright) {
        this.isShowCopyright = false
      } else {
        this.isShowCopyright = true
      }
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/layouts/NormalLayout.vue